import { GET, PUT } from 'utils/requests.utils'

const BASE_URL = '/common/team_member'

export const fetchItem = () => GET(BASE_URL)

export const updateItem = (data) => PUT(BASE_URL, data)
